import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function Footer() {
  const { t } = useLanguage();
  
  // PimpMyDrop official social media links
  const pimpMyDropSocialMedia = [
    { url: 'https://www.instagram.com/pimpmydrop/', platform: 'Instagram', icon: 'fab fa-instagram' },
    { url: 'https://x.com/pimpmydrop', platform: 'X', icon: 'fab fa-x-twitter' },
    { url: 'https://www.tiktok.com/@pimpmydrop', platform: 'TikTok', icon: 'fab fa-tiktok' },
    { url: 'https://discord.gg/t4xhh7WE6v', platform: 'Discord', icon: 'fab fa-discord' }
  ];
  
  const socialLinks = pimpMyDropSocialMedia;
  
  return (
    <footer className="bg-black text-white py-12 border-t border-gray-800">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="mb-8 md:mb-0">
            <div className="flex flex-col items-start mb-4">
              <a href="/">
                <img 
                  src="https://res.cloudinary.com/dez2cotie/image/upload/v1748665915/Logo_PimpMyDrop_wqgnao.webp" 
                  alt="Pimp My Drop Logo" 
                  className="h-[5rem]" 
                />
              </a>
            </div>
            <p className="text-gray-400 mb-4">
              {t('platformDescription')}
            </p>
            <div className="flex space-x-4 flex-wrap gap-y-2">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.url} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-cyan-500 transition-colors duration-300"
                  title={social.platform}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('quickLinks')}</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">{t('home')}</a></li>
              <li><a href="/submit" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">{t('submit')}</a></li>
              <li><a href="/gallery" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">{t('vote')}</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('information')}</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="mailto:contact@pimpmydrop.com" 
                  className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
                >
                  {t('contact')}
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('legalInformation')}</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="/terms" 
                  className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
                >
                  {t('termsAndConditions')}
                </a>
              </li>
              <li>
                <a 
                  href="/legal-notices" 
                  className="text-gray-400 hover:text-cyan-400 transition-colors duration-300"
                >
                  {t('legalNotices')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-500">
          <p>&copy; {new Date().getFullYear()} PimpMyDrop. {t('allRightsReserved')}.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
